import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { trips } from './trips.schema';

export const logs = sqliteTable('logs', {
  id: text('id').notNull().primaryKey(),
  trip_id: integer('trip_id'),
  trip_uuid: text('trip_uuid').references(() => trips.id),
  boat_detail_id: integer('boat_detail_id'),
  boat_detail_uuid: text('boat_detail_uuid'),
  category_id: integer('category_id'),
  category_uuid: text('category_uuid'),
  organization_id: text('organization_id'),
  user_id: integer('user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  datetime: text('datetime'),
  longitude: real('longitude'),
  latitude: real('latitude'),
  type: text('type'),
  caption: text('caption'),
  creation_type: text('creation_type'),
  creator_agent_name: text('creator_agent_name'),
  is_enabled: integer('is_enabled'),
  name: text('name'),
  notes: text('notes'),
  imminent: text('imminent'),
  later: text('later'),
  outlook: text('outlook'),
  channel: text('channel'),
  station: text('station'),
  message: text('message'),
  speed: real('speed'),
  sog: real('sog'),
  heading: integer('heading'),
  cog: integer('cog'),
  log: real('log'),
  depth: real('depth'),
  helm: text('helm'),
  sails: text('sails'),
  sea_area: text('sea_area'),
  event: text('event'),
  diesel_generator_rpm: integer('diesel_generator_rpm'),
  diesel_generator_hours: real('diesel_generator_hours'),
  diesel_generator_status: integer('diesel_generator_status'),
  diesel_generator_oil_check: integer('diesel_generator_oil_check'),
  diesel_generator_fuel_check: integer('diesel_generator_fuel_check'),
  diesel_generator_water_check: integer('diesel_generator_water_check'),
  diesel_generator_exhaust_check: integer('diesel_generator_exhaust_check'),
  engine_status1: integer('engine_status1'),
  engine_hours1: real('engine_hours1'),
  engine_rpm1: integer('engine_rpm1'),
  engine_fuel_check1: integer('engine_fuel_check1'),
  engine_oil_check1: integer('engine_oil_check1'),
  engine_water_check1: integer('engine_water_check1'),
  engine_exhaust_check1: integer('engine_exhaust_check1'),
  engine_status2: integer('engine_status2'),
  engine_hours2: real('engine_hours2'),
  engine_rpm2: integer('engine_rpm2'),
  engine_fuel_check2: integer('engine_fuel_check2'),
  engine_oil_check2: integer('engine_oil_check2'),
  engine_water_check2: integer('engine_water_check2'),
  engine_exhaust_check2: integer('engine_exhaust_check2'),
  battery1: real('battery1'),
  battery2: real('battery2'),
  boat_water: real('boat_water'),
  fuel: real('fuel'),
  gas: real('gas'),
  bilge: integer('bilge'),
  wind_speed: real('wind_speed'),
  wind_direction: integer('wind_direction'),
  air_temp: real('air_temp'),
  sea_temp: real('sea_temp'),
  visibility: real('visibility'),
  bar: real('bar'),
  sky: integer('sky'),
  sea_state: integer('sea_state'),
  precipitation: text('precipitation'),
  laravel_id: integer('laravel_id'),
});
